import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WalletSections } from '../../../../model';
import { WalletCommonState } from './common-types';

const initialState: WalletCommonState = {
  selectedSection: 'MY_WALLET',
};

const walletCommonSlice = createSlice({
  name: 'features/walletStore/common',
  initialState: () => {
    return initialState;
  },
  reducers: {
    resetWalletCommonState() {
      return initialState;
    },
    setSelectedWalletSection(state, action: PayloadAction<WalletSections>) {
      state.selectedSection = action.payload;
    },
  },
});

export const walletCommonSliceActions = walletCommonSlice.actions;

export default walletCommonSlice.reducer;
